import { versionedStyleConfig } from '@joinrepublic/dls-ui-core';

import { styleConfig as vPrevious } from './2.1';
import { styleConfig as vCurrent } from './2.2';

export const styleConfig = versionedStyleConfig({
  current: vCurrent,
  previous: { version: '2.1', config: vPrevious },
  // Elements that bypass the kit are never stamped, and `Heading` imported straight from
  // `@chakra-ui/react` is still all over the app. Keep them on 2.1 — the kit's `versions.ts`
  // says the same for unversioned `<Heading>`, and the two have to be flipped together.
  defaultVersion: '2.1',
});
